import { formatGiB } from '~/shared/utils/formatNumber';

/** Formats exploration volume size; input is GiB (from `ExplorationVolume.size`). */
export function formatBytes(gib: number | null | undefined): string {
  return formatGiB(gib ?? undefined);
}

export function volumeDisplayName(v: { name?: string; ebsId?: string } | null | undefined): string {
  if (!v) return '';
  const n = (v.name || '').trim();
  if (n && n !== v.ebsId) return n;
  return v.ebsId || '';
}

export function volumeHasFriendlyName(v: { name?: string; ebsId?: string } | null | undefined): boolean {
  if (!v) return false;
  const n = (v.name || '').trim();
  return !!n && n !== v.ebsId;
}

/** Region/diskType subtitle; includes ebsId only when a friendly name is shown as the title. */
export function volumeSubtitle(
  v: { name?: string; ebsId?: string; region?: string; diskType?: string } | null | undefined
): string {
  if (!v) return '';
  const parts = [
    ...(volumeHasFriendlyName(v) ? [v.ebsId] : []),
    v.region,
    (v.diskType || '').toUpperCase(),
  ].filter(Boolean);
  return parts.join(' | ');
}

export function truncate(s: string, n: number): string {
  const str = String(s || '');
  return str.length > n ? `${str.slice(0, n)}…` : str;
}
